import React from 'react'
import { change, show, success as changeSuccess } from '../../../store/actions/gestor.action'
import { CircularProgress, AppBar, Toolbar, IconButton, Typography, CardHeader, Avatar } from '@material-ui/core'
import { MdContentCopy, MdKeyboardBackspace } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen } from '../../../store/actions/navigation.action'
import { FaLock } from 'react-icons/fa'
import { domain } from '../../../config/App'
import { changeNotify } from '../../../store/actions/notify.action'

export default function GestorAccess(props) {
    const dispatch = useDispatch()
    const { gestor } = useSelector(state => state.gestorReducer)
    const id = (props.uid) ? props.uid : null

    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        if(id) {
            dispatch(show(id)).then(res => res && setLoading(false))
        }else {
            window.location.replace('/gestores')
        }
        
        return () => {
            dispatch(change('clear'))
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
		var clipboard = new window.ClipboardJS('.copy');

		clipboard.on('success', function(e) {
            dispatch(changeNotify({
                open: true,
                msg: 'Link copiado com sucesso',
                class: 'success'
            }))
		});
	},[])

    return (
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        Dados de acesso
                    </Typography>
                </Toolbar>
            </AppBar>

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card card-body mt-3 bs-bg">
                        <CardHeader
                            avatar={
                                <Avatar>
                                    <FaLock />
                                </Avatar>
                            }
                            title={
                                <div className="d-flex align-items-center">
                                    <h6 className="fw-bold mb-1 bs-color-b">{'https://gestor.'+domain}</h6>
                                    <IconButton className='copy bs-color' data-clipboard-target={"#copy-link"}>
                                        <MdContentCopy />
                                    </IconButton>
                                    <input type="text" style={{opacity: '0', position: 'fixed', left: '-9999px'}} value={'https://gestor.'+domain} id="copy-link" readOnly/>
                                </div>
                            }
                            subheader={
                                <>
                                    <span className="d-block bs-color">Email: {gestor.email}</span>
                                    <span className="d-block bs-color">Senha: ********</span>
                                </>
                            }
                        />
                    </div>
                </>
            }
        </div>
    )
}